export enum MediaType {
    json = 'application/json',
    pdf = 'application/pdf',
    zip = 'application/zip',
    html = 'text/html',
    css = 'text/css',
    csv = 'text/csv',
    any = '*/*',
}
